import React, {Suspense} from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";

import {userManager} from "./managers/UserManager";
import {useCloudApi} from "@shared/hooks/useCloudApi";

import {LoadingPage} from "./containers/LoadingPage";
import {AccountPage} from "./containers/account/AccountPage";
import {OrdersPage} from "./containers/orders/OrdersPage";
import {DevicesPage} from "./containers/devices/DevicesPage";
import {SubscriptionsPage} from "./containers/subscriptions/SubscriptionsPage";
import {SelfHostedServersPage} from "./containers/self-hosted-servers/SelfHostedServersPage";
import {BackupsPage} from "./containers/backups/BackupsPage";
import {Menu} from "./containers/menu/Menu";

function App() {
  const user = userManager.store(state => state.user); // User is updated on state change.
  const [isLoading] = useCloudApi({
    onUser: (cloudApiUser) => {
      userManager.setUser(cloudApiUser);
    },
    onLogout: () => {
      try {
        if (typeof window !== 'undefined') {
          window.hyLogoutInProgress = true;
        }
      } catch (error) {
        console.error(error);
      }
      userManager.setUser(null);
      window.location.href = "/";
    },
  });

  const myAccountSlug = "/account";
  const baseIndex = typeof window !== "undefined" ? window.location.pathname.indexOf(myAccountSlug) : -1;
  const basename = baseIndex >= 0 ? window.location.pathname.slice(0, baseIndex + myAccountSlug.length) : myAccountSlug;

  if (isLoading) {
    return <LoadingPage/>;
  }
  if (!user) {
    // If a logout just occurred, don't trigger login again; the logout handler will redirect to "/".
    if (typeof window === 'undefined' || !window.hyLogoutInProgress) {
      const hyWebsite = window.hyWebsite;
      const cloudApi = hyWebsite.getCloudAPI();
      cloudApi.login();
    }
    return <LoadingPage/>;
  }

  return (
    <Suspense fallback={<LoadingPage/>}>
      <BrowserRouter basename={basename}>
        <div className="account">
          <div className="edge">
            <div className="account__container">
              <Menu user={user}/>
              <Routes>
                <Route path="/" element={<AccountPage/>}/>
                <Route path="/orders/" element={<OrdersPage/>}/>
                <Route path="/subscriptions/" element={<SubscriptionsPage/>}/>
                <Route path="/devices/" element={<DevicesPage/>}/>
                <Route path="/self-hosted-servers/" element={<SelfHostedServersPage/>}/>
                <Route path="/backups/" element={<BackupsPage/>}/>
                <Route path="/account/" element={<Navigate to="/" replace/>}/>
              </Routes>
            </div>
          </div>
        </div>
      </BrowserRouter>
    </Suspense>
  )
}

const domContainer = document.querySelector("#account-root");
const root = ReactDOM.createRoot(domContainer);
root.render(<React.StrictMode><App/></React.StrictMode>);
